import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgxPictureModule, DEFAULT_BREAKPOINTS } from 'ngx-picture';
import { SecureFilePipe, UiKitModule } from '@ui-kit';
import { DROPZONE_CONFIG, DropzoneConfigInterface, DropzoneModule } from 'ngx-dropzone-wrapper';
import { SHARED_COMPONENTS } from './component/index';
import { SHARED_DIRECTIVES } from './directive/index';
import { SHARED_PIPES } from './pipe/index';
import { SHARED_SERVICES } from './service/index';
import { environment } from '../../environments/environment';

const DEFAULT_DROPZONE_CONFIG: DropzoneConfigInterface = {
  // Change this to your upload POST address:
  url: `${environment.urls.api}/file`,
  maxFilesize: 50,
  acceptedFiles: 'image/*,application/*,',
};

export const COMMON = [
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
  RouterModule,
  HttpClientModule,
  // NgxChartsModule,
  UiKitModule,
  DropzoneModule,
];

@NgModule({
  imports: [
    ...COMMON,
    NgxPictureModule.forRoot({
      breakpoints: DEFAULT_BREAKPOINTS,
      srcInterpolator: (v) => v,
    }),
  ],
  exports: [
    ...COMMON,
    ...SHARED_COMPONENTS,
    ...SHARED_DIRECTIVES,
    ...SHARED_PIPES,
    NgxPictureModule,
  ],
  declarations: [
    ...SHARED_COMPONENTS,
    ...SHARED_DIRECTIVES,
    ...SHARED_PIPES,
  ],
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [
        ...SHARED_SERVICES,
        {
          provide: DROPZONE_CONFIG,
          useValue: DEFAULT_DROPZONE_CONFIG,
        },
        SecureFilePipe,
      ],
    };
  }
}
